import React, { useId } from "react";
import { FaBullseye, FaCoins } from "react-icons/fa";
import { elakayAutoText as text } from "./dataElakay";
import "./salesSimulation.css";
import "./PricingModeSelector.css";

// The same pricing intent control is used by Sales Simulation and Product pricing.
// Values match the backend's shared Sales Simulation engine.
export default function PricingModeSelector({ value, onChange, disabled = false, name }) {
  const id = useId();
  const groupName = name || `pricing-mode-${id}`;
  const options = [
    ["selling_price", text("h_ps_target_price", "Target Selling Price"), FaBullseye],
    ["desired_profit", text("h_ps_desired_profit", "Desired Profit"), FaCoins],
  ];
  return (
    <div className="sales-sim pricing-mode-selector">
      <div className="sim-toggle" role="radiogroup" aria-label={text("h_ps_pricing_mode", "Pricing Mode")}>
        {options.map(([mode, label, Icon]) => (
          <span className="sim-toggle-option" key={mode}>
            <input id={`${id}-${mode}`} type="radio" name={groupName} value={mode}
              checked={value === mode} disabled={disabled} onChange={() => onChange(mode)} />
            <label htmlFor={`${id}-${mode}`}><Icon aria-hidden="true" />{label}</label>
          </span>
        ))}
      </div>
    </div>
  );
}
